import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const IMG =
  "https://images.pexels.com/photos/14522762/pexels-photo-14522762.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export default function ParallaxDivider() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-18%", "18%"]);

  return (
    <section
      ref={ref}
      className="relative h-[60vh] md:h-[85vh] w-full overflow-hidden border-b border-white/10"
      data-testid="parallax-divider"
    >
      <motion.div style={{ y }} className="absolute inset-0 z-0 scale-125">
        <img
          src={IMG}
          alt="Offshore rig in stormy seas"
          className="h-full w-full object-cover grayscale-[30%]"
        />
        <div className="absolute inset-0 bg-background/45" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1600px] h-full px-5 md:px-10 flex items-center">
        <motion.blockquote
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-4xl"
        >
          <p className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl lg:text-6xl leading-[0.95] text-foreground">
            When the weather closes in and the clock is running,
            <span className="text-primary"> the line still has to reach depth.</span>
          </p>
        </motion.blockquote>
      </div>
    </section>
  );
}
